import { Theme } from "@mui/material/styles";

export const typography = (theme: Theme, ownerState?: { fontSize?: string; fontWeight?: number }) => {
    const fontSize = ownerState?.fontSize || "1rem";
    const fontWeight = ownerState?.fontWeight || 100;

    return {
        fontSize,
        fontWeight,
    };
};

export const container = () => ({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
});

export const colorBox = (theme: Theme, ownerState: { disabled: boolean }) => ({
    p: 1,
    border: "1px solid #f4f4f4",
    backgroundColor: "#f8f8f8",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 2,
    position: "relative",
    borderRadius: 1,
    cursor: ownerState.disabled ? "unset" : "pointer",
});

export const popup = () => ({
    position: "absolute",
    bottom: 95,
    zIndex: 2,
});
